const jwt_secret = "NewYorkBurger";
export default jwt_secret;